var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
var ARGUMENT_NAMES = /([^\s,]+)/g;
function args(func) {
    var fnStr = func.toString().replace(STRIP_COMMENTS, '');
    var result = fnStr.slice(fnStr.indexOf('(') + 1, fnStr.indexOf(')')).match(ARGUMENT_NAMES);
    var rStr = "return\\s*" + result[0] + ".([^;]*)";
    var findRet = new RegExp(rStr, "mg");
    var res = findRet.exec(fnStr);
    if (res)
        return res[1].split(".");
    return [];
}
export function getPath(func1) {
    return args(func1);
}
export function applyPath(val, func1) {
    var p = getPath(func1);
    var c = val;
    var i = 0;
    while (c && i < p.length)
        c = c[p[i++]];
    return c;
}
//# sourceMappingURL=PathHelpers.js.map